import React from 'react';
import styled from 'styled-components';
import GraphView from './components/GraphView.js';
import { keyframes } from 'styled-components';
import info from "./data/information.json";
import DropdownView from "./components/DropdownView.js";

const Filters = styled.div`
    display: flex; 
    flex-direction: column;
    @media (max-width: 1253px) {
        flex-direction: row; 
        div.filter{
            display: flex;
            flex-direction: column;
            margin-right: 80px; 
        }
    }
    @media (max-width: 900px){
        flex-direction: column;
        div.filter{
            margin-bottom: 24px; 
        }
    }
`

const TimelineView = styled.div`
    display: flex; 
    flex-direction: row; 
    position: relative;
    align-items: center;
    justify-content: space-between;
    width: 100%; 
    max-width: 100%; 
    @media (max-width: 1253px){
        display: none; 
    }
    margin-bottom: 40px;
`
const StyledTimeline = styled.div`{
    position: relative;
    display: block; 
    width: 100%;
    div.milestones{
        display: flex; 
        flex-direction: row; 
        justify-content: space-between;
        position: relative; 
        width: inherit;
        cursor: pointer;
    }
    margin-right: 48px; 
    margin-left: 4px; 
}`


const Line = styled.div`
    width: 100%;
    height: 2px; 
    border-radius: 10px; 
    position: absolute;
    top: 50%; 
    align-self: center;
    margin: auto 0px; 
    z-index: 0; 
    background-color: #E1E1E7;
`

const StyledIndicator = styled.div`
    transform: scaleX(${props => props.scale});
    width: 12.4%; 
    transform-origin: center left; 
    height: 2px; 
    position: absolute;
    top: 50%; 
    left: 0; 
    z-index: 20; 
    background-color: #66666A;

    // animation-name: $grow};
    // animation-duration: 1s; 
    // animation-timing-function: linear; 
    // animation-iteration-count: infinite; 
`

const StyledMilestone = styled.div`{
    display: flex; 
    flex-direction: column; 
    align-items: center;
    div.circle{
        border-radius: 20px; 
        width: 32px; 
        height: 32px;
        position: relative; 
        z-index: 100; 
        background-color: ${
            props => props.isActive >= props.id ?
                "#F0F0F2" :
                "#ffffff"
        };
        border: ${
            props => props.isActive >= props.id ?
                "2px solid #66666A" :
                "2px solid #E1E1E7"
        };
    } 
    color: ${
        props => props.isActive >= props.id ?
            "#263238" :
            "#86868B"
    };
    div.label{
        font-weight:500;
        position: absolute;
        top: 100%;
        width: auto;
        white-space: nowrap;
        margin: 8px auto 0px auto; 
        text-align: center;
    }
    visibility: ${
        props => props.name != "3.5 Years" ?
            "visible"
            : 
            "hidden"
    };
    :hover {
        div.label {
            color: #263238;
        }
        div.circle{
            border-color: #66666A;

        }
    }
}`

// const grow = keyframes`
//     0% {scaleX: 0%; };
//     100% { scaleX: 100%; };
// `

const ViewAll = styled.button`{
    display: block; 
    position: relative;
    min-width: 159px;
    font-weight: bold;
    padding: 16px 12px;
    margin: 0;  
    border: ${
        props => props.isActive == true ?
        "1px solid #66666A" :
        "1px solid #E1E1E7"
    };
    border-radius: 5px; 
    background-color: ${
        props => props.isActive == true ?
            "#F0F0F2" :
            "transparent"
    };
    :hover {
        background-color: #F0F0F2;
        border-color: #66666A;
        h4{
            color: #1D1D1F;
        }
    }
    h4{
        color: ${
        props => props.isActive == true ?
            "#1D1D1F" :
            "#86868B" 
    };
    }
}`

const StyledOutcomesBar = styled.div`{
    display: flex;
    flex-direction: row; 
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    @media (max-width: 1253px){
        display: none; 
    }
}`

const StyledOutcome = styled.div`{
    display: flex;
    flex-direction: row;
    min-width: 212px; 
    align-items: center;
    text-decoration: none; 
    cursor: pointer;
    padding: 16px 0px;
    }
    border: ${
        props => props.isActive == props.name ?
        "1px solid #66666A" :
        "1px solid #E1E1E7"
    };
    border-radius: 5px;
    background-color: ${
        props => props.isActive == props.name ?
            "#F0F0F2" :
            "transparent"
    };
    :hover {
        background-color: #F0F0F2;
        border-color: #66666A;
        h4 {
            color: #1D1D1F;
        }
    }
    h4{
        color: ${
            props => props.isActive == props.name ?
                "#1D1D1F" :
                "#86868B"
        };
        margin: 0px auto;
    }
}`

const Chart = styled.div`
    margin: 40px auto;
    width: 100%; 
`

const Info = styled.div`
    display: flex; 
    flex-direction: column; 

    div.about{
        display: flex; 
        // flex-direction: row; 
        // justify-content: space-between; 

        @media (max-width: 1024px){
            flex-direction: column;
            margin-bottom: 40px; 
        }

        div.decoration{
            width: 2px; 
            background-color: #F1F1F4;
            margin-right: 24px;
        }

        div.content{
            max-width: 422px; 
        }

        div.milestoneInfo{
            display: flex; 
            flex-direction: row; 
            max-width: 450px; 
            height: fit-content;
            float: left; 
            margin-right: 80px; 
            @media (max-width: 1024px){
                margin-bottom: 40px; 
            }
        }

        div.outcomeInfo{
            display: flex; 
            flex-direction: row; 
            height: fit-content;
            max-width: 450px; 
        }
        
        p{
            margin-bottom: 0px; 
        }
    }

    div.learnMore{
        align-self: flex-start;
        margin: 24px 0px 48px 0px;
    }
    
    div.learnMore a{ 
        display: flex; 
        flex-direction: row; 
        justify-content: center; 
        h4{
            margin-left: 12px;
        }
        text-decoration:none;
        :hover{
            text-decoration: underline;
        }
    }

`
const StyledDataView = styled.div`
    display: flex; 
    flex-direction: column;
`

class DataView extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            milestones: [
                {
                    name: "Day 0",
                    id: 1,
                    info: "Day 0 refers to the first day after you receive your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 6 Months milestone.",
                    key: 1
                },
                {
                    name: "6 Months",
                    id: 2,
                    info: "6 Months refers to when it has been 6 months since you received your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 1 Year milestone.",
                    key: 2
                },
                {
                    name: '1 Year',
                    info: "1 Year refers to when it has been a year since you received your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 1.5 Years milestone.",
                    id: 3,
                    key: 3
                },
                {
                    name: '1.5 Years',
                    info: "1.5 Years refers to when it has been 1 and a half years, or 18 months since you received your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 2 Year milestone.",
                    id: 4,
                    key: 4
                },
                {
                    name: '2 Years',
                    info: "2 Years refers to when it has been 2 years, or 24 months since you received your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 2.5 Years milestone.",
                    id: 5,
                    key: 5
                },
                {
                    name: '2.5 Years',
                    info: "2.5 Years refers to when it has been 2 and a half years, or 30 months since you received your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 3 Years milestone.",
                    id: 6,
                    key: 6
                },
                {
                    name: '3 Years',
                    info: "3 Years refers to when it has been 3 years, or 36 months since you received your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 3.5 Years milestone.",
                    id: 7,
                    key: 7
                },
                {
                    name: '3.5 Years',
                    info: "3.5 Years refers to when it has been 3 and a half years, or 42 months since you received your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 4 Years milestone.",
                    id: 8,
                    key: 8
                },
                {
                    name: '4 Years',
                    info: "4 Years refers to when it has been 4 years, or 48 months since you received your stem cell transplant. This is the last milestone.",
                    id: 9,
                    key: 9
                },
            ],
            activeId: 1,
            activeMilestone: "Day 0",
            milestoneInfo: "Day 0 refers to the first day after you receive your stem cell transplant. Your prognosis for this time period reflects the likelihood of the selected outcome from this day until the 6 Months milestone.",
            scale: 0,
            activeAll: false,
            selectedMilestone: '', //dropdown state
            selectedOutcome: '', //dropdown state
            outcomes: [
                {
                    name: 'Overall Survival Rate',
                    info: "Overall Survival Rate is an estimation of your chances of survival without the context of complete remission or relapse.",
                    key: 1
                },
                {
                    name: 'Survival in CR1',
                    info: "Survival in Complete Remission 1 is an estimation of your chances of survival in complete remission, without having experienced relapse.",
                    key: 2
                },
                {
                    name: 'Survival With Relapse',
                    info: "Survival With Relapse is an estimation of your chances of survival after a relapse.",
                    key: 3
                },
                {
                    name: 'aGvHD',
                    info: "This rate is an estimation of your chances of developing Severe Acute Graft versus Host Disease.",
                    key: 4
                },
                {
                    name: 'cGvHD',
                    info: "This rate is an estimation of your chances of developing Chronic Graft versus Host Disease requiring systemic therapy.",
                    key: 5
                }
            ],
            changeKey: 0,
            activeOutcome: "Overall Survival Rate",
            outcomeInfo: "Overall Survival Rate is an estimation of your chances of survival without the context of complete remission or relapse."
        };
        this.onMilestoneClick = this.onMilestoneClick.bind(this);        
        this.onOutcomeClick = this.onOutcomeClick.bind(this); 
        this.onMilestoneSelect = this.onMilestoneSelect.bind(this)
        this.onOutcomeSelect = this.onOutcomeSelect.bind(this)


    }

    onMilestoneClick = (name) => {
        this.setState ({activeAll: false}); 
        this.setState ({activeMilestone: name}); 
        var scale;
        switch (name) {
            case 'Day 0':
              scale = 0; break; 
            case '6 Months':
                scale = 1; break;
            case '1 Year':
              scale = 2; break;          
            case '1.5 Years':
              scale = 3; break;
            case '2 Years':
              scale = 4; break; 
            case '2.5 Years':
              scale = 5; break; 
            case '3 Years':
              scale = 6; break;
            case '4 Years':
              scale = 8; break;
            default:
               scale = 0; break;
          }

        const id = this.state.milestones[scale].id;
        const info = this.state.milestones[scale].info;

        this.setState ({scale: scale}); 
        this.setState ({activeId: id}); 
        this.setState ({milestoneInfo: info}); 
        this.setState({changeKey: id});
    }

    onOutcomeClick = (name) => {
        var info = '';
        const outcomes = this.state.outcomes;
        const index=[0,1,2,3,4];

        index.map((i) => 
        {
            if (outcomes[i].name == name ) info=outcomes[i].info;
        });

        (this.state.changeKey === 10) ? this.setState({changeKey: 9}) : this.setState({changeKey: 10}); 
        this.setState({activeOutcome: name}); 
        this.setState({outcomeInfo: info});
    }

    onViewAllClick = () => {
        this.setState({activeAll: true}); 
        this.setState({scale: 0}); 
        this.setState({activeId: 0}); 
        this.setState({activeMilestone: "Comparing All Rates"}); 
        this.setState({milestoneInfo: "Comparing All Rates provides a few of all rates for each milestone for the selected outcome."}); 
    }

    onMilestoneSelect(option){
        if (option.value == "View All"){
            this.onViewAllClick(); 
        } else{
            this.onMilestoneClick(option.value);
        }
        // (this.state.changeKey === 11) ? this.setState({changeKey: 12}) : this.setState({changeKey: 11});
    }

    onOutcomeSelect(option){
        this.onOutcomeClick(option.value); 
        // this.setState({activeOutcome: option.value});
        // (this.state.changeKey === 13) ? this.setState({changeKey: 14}) : this.setState({changeKey: 13});
    }

    render(){
        const {milestones, milestoneInfo, activeId, activeMilestone, scale,
            outcomes, outcomeInfo, activeOutcome, activeAll, changeKey} = this.state;
        return(
            <StyledDataView>
                <Filters>
                    <div className="filter">
                        <h5>Filter by Milestone</h5>
                        <TimelineView>
                            <Timeline milestones={milestones} activeId={activeId} activeM={activeMilestone} scale={scale} onClick={this.onMilestoneClick}/>
                            <ViewAll isActive={activeAll} onClick={this.onViewAllClick}><h4>View All</h4></ViewAll>
                        </TimelineView>
                        <DropdownView category={"milestones"} onChange={this.onMilestoneSelect} selected={activeMilestone}/>
                    </div>
                    <div className="filter">
                        <h5>Filter by Outcome</h5>
                        <OutcomesBar outcomes={outcomes} active={activeOutcome} onClick={this.onOutcomeClick}></OutcomesBar>
                        <DropdownView category={"outcomes"} onChange={this.onOutcomeSelect} selected={activeOutcome}/>
                    </div>
                </Filters>
                <Chart>
                    <GraphView key={changeKey} milestone={activeMilestone} outcome={activeOutcome} line={activeAll}/>
                </Chart>
                <Info>
                    <h2>{activeMilestone} for {activeOutcome == "aGvHD" ? "Acute Graft versus Host Disease" : 
                    (activeOutcome == "cGvHD" ? "Chronic Graft versus Host Disease" : activeOutcome)}</h2>
                    <div className="about">
                        <div className="milestoneInfo">
                            <div className="decoration"></div>
                            <div className="content">
                                <h3>About {activeMilestone}</h3>
                                <p>{milestoneInfo}</p>
                            </div>
                        </div>
                        <div className="outcomeInfo">
                            <div className="decoration"></div>
                            <div className="content">
                                <h3>About {activeOutcome}</h3>
                                <p>{outcomeInfo}</p>
                            </div>
                        </div>
                    </div>
                    <div className="learnMore">
                        <a href="prognosis"><img src= {require( './img/info.svg')} style={{marginRight: 8 + 'px'}}/>
                        Learn more about the algorithm</a>
                    </div>
                </Info>
            </StyledDataView>
        )
    }
}

class Indicator extends React.Component{
    render(){
        const {scale} = this.props;
        return (
            <StyledIndicator scale={scale}>
            </StyledIndicator>  
        )
    }
}

class Milestone extends React.Component{
    handleClick = () => {
        //need these to be passed in as props
        const { name, onClick} = this.props;
        onClick(name); //onMilestoneClick from props
    }

    render(){
        /*gets the props*/
        const {name, activeId, id, activeM} = this.props;
        return (
            <StyledMilestone onClick={this.handleClick} name={name} isActive={activeId} id={id} activeM={activeM}>
                <div className="circle"></div>
                <div className="label">{name}</div>
            </StyledMilestone>       
        );
    }
}

class Timeline extends React.Component{
    render(){
        const {milestones, activeId, activeM, scale, onClick } = this.props;
        return (
            <StyledTimeline>
                <Line/>
                <Indicator scale={scale}/>
                <div className="milestones">
                    {
                        milestones.map((item) => {
                            return (
                                <Milestone name={item.name} 
                                key={item.key} 
                                onClick = {onClick}
                                id={item.id}
                                activeId={activeId}>
                                activeM={activeM}>
                                </Milestone>
                            )
                        })
                    }
                </div>
            </StyledTimeline>
        )
    }  
}

class Outcome extends React.Component{
    handleClick = () => {
        const { name, onClick } = this.props;
        onClick(name);
    }

    render(){
        const {name, activeLink} = this.props;
        return (
            <StyledOutcome onClick={this.handleClick} name={name} isActive={activeLink}>
                <h4>{name}</h4>
            </StyledOutcome>   
        );
    }
}

class OutcomesBar extends React.Component {
    render(){
        const {outcomes, active, onClick } = this.props;
        return (
            <StyledOutcomesBar>
                {
                    outcomes.map((item) => {
                        return (
                            <Outcome name={item.name} 
                            key={item.key} 
                            onClick={onClick}
                            activeLink={active}>
                            </Outcome>
                        )
                    })
                }
            </StyledOutcomesBar>
        )
    }
}

export const Prognosis = (props) => (
    <div className="custom-container">
        <h1>Prognosis</h1>
        <DataView></DataView>
        {/* {renderLineChart} */}
    </div>
  )